<div class="modal-header">
  <h4
    class="modal-title"
    i18n="create delivery form title|The title of the delivery form modal when a new delivery is being created@@newDeliveryFormTitle"
    *ngIf="isNew"
  >New Delivery</h4>
  <h4
    class="modal-title"
    i18n="edit delivery form title|The title of the delivery form modal when a previous delivery is being edited is being created@@editDeliveryFormTitle"
    *ngIf="!isNew"
  >Edit Delivery</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(null)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="deliveryForm">
    <input type="hidden" formControlName="IdDelivery" />
    <div class="section larger">
      <div class="section-container">
        <div class="form-group">
          <label i18n="delivery form subject input label|The label of the subject of the email that is being configured at the delivery form@@deliveryFormWrapper">Subject</label>
          <input
            type="text"
            class="form-control"
            formControlName="Subject"
            ngbAutofocus
          />
        </div>
        <div class="form-group message">
          <label i18n="delivery form message input label|The label of the input for the message of the email that is being configured at the delivery form@@deliveryMessageFormLabel">Message</label>
          <app-kothing-html-editor type="average" [control]="Message" [height]="messageEditorHeight"></app-kothing-html-editor>
        </div>
      </div>
    </div>
    <div class="section smaller">
      <div class="form-group report-type">
        <label>Report Type</label>
        <select formControlName="ReportType" class="form-control">
          <option i18n="select report type email|The report type select label at the delivery form modal for Email@@selectReportTypeEmail" value="email">Email</option>
          <option i18n="select report type whatsapp|The report type select label at the delivery form modal for Whatsapp@@selectReportTypeWhatsapp" value="whatsapp" disabled>Whatsapp (coming soon)</option>
        </select>
      </div>
      <div class="form-group filter">
        <label>Filters</label>
        <div
        class="applied-filter-string"
        *ngIf="filterAppliedCount === undefined || filterAppliedCount === 0"
        i18n="delivery no filters applied|The status of a delivery form with no filter applied to its pages@@noFiltersSelectedDeliveryForm"
        >No filters applied</div>
        <div
        class="applied-filter-string"
        *ngIf="filterAppliedCount === 1"
        i18n="a single filter applied label|The label when a single filter is applied in the delivery form page@@deliveryFormSingleFilterApplied"
        >1 filter applied</div>
        <div class="applied-filter-string" *ngIf="filterAppliedCount !== undefined && filterAppliedCount > 1">{{ filterAppliedCount }}<span style="margin-left:4px" i18n="plural filter applied sufix|The sufix after the number of filters applied in the delivery form page@@deliveryFormPluralFiltersApplied">filter applied</span></div>
        <button type="button" class="btn btn-primary btn-with-left-icon" (click)="onEditFilterClick()">
          <i class="fa fa-external-link" *ngIf="!loadingFilterElement"></i>
          <i class="fa fa-circle-o-notch fa-spin-fast" *ngIf="loadingFilterElement"></i>
          <span
          i18n="edit filter button label|The button label to edit the filter on the delivery form modal@@editDeliveryModalFilterButtonLabel"
          >Edit Filters</span>
        </button>
        <button type="button" [ngClass]="{'btn': true, 'btn-secondary': true, 'disabled': filterAppliedCount === undefined}" (click)="onResetFilterClick()" [disabled]="filterAppliedCount === undefined">
          <span
          i18n="reset filter button label|The button label to reset the filters on the delivery form modal@@resetDeliveryModalFilterButtonLabel"
          >Reset Filters</span>
        </button>
        <div
        class="info-filter-string"
        i18n="Report Filter Info@@reportFilterInfo"
        >Info: In this step you should only use the report filters.</div>
      </div>
      <div class="form-group tab-selector">
        <div class="button-group btn-group">
          <button (click)="onSelectTabView('contacts')" [ngClass]="'btn btn-default btn-full-width' + (rightTabView === 'contacts' ? ' selected' : '')">
            <span i18n="contact label input indicator|The label above the contact input list selector at the delivery form modal@@contactInputLabelDeliveryModal">Contacts</span>
            <span class="badge" style="margin-left: 4px">{{ '(' + selectedContacts.length.toString() + ')' }}</span>
          </button>
          <button (click)="onSelectTabView('tags')" [ngClass]="'btn btn-default btn-full-width' + (rightTabView === 'tags' ? ' selected' : '')">
            <span i18n="tag label input indicator|The label above the tag input list selector at the delivery form modal@@tagInputLabelDeliveryModal">Tags</span>
            <span class="badge" style="margin-left: 4px">{{ '(' + selectedTags.length.toString() + ')' }}</span>
          </button>
        </div>
        <div class="tab-content">
          <div class="tab contacts" *ngIf="rightTabView === 'contacts'">
            <label>
              <span
                i18n="contact label input indicator|The label above the contact input list selector at the delivery form modal@@contactInputLabelDeliveryModal"
              >Contacts</span>
              <span></span>
              <span *ngIf="selectedContacts.length != 0"> (</span>
              <span
                *ngIf="selectedContacts.length == 1"
                i18n="one contact selected sufix|The sufix at the right of the contact label that lets the user know there is a single contact selected@@contactLabelSufixSingleDeliveryModal"
              >1 contact selected</span>
              <span *ngIf="selectedContacts.length > 1">
                <span>{{ selectedContacts.length }}</span>
                <span style="margin-left: 4px;" i18n="plural contact count sufix|The qualifier sufix at the right of the number of contacts currently selected for a delivery@@contactLabelSufixPluralDeliveryModal">contacts selected</span>
              </span>
              <span *ngIf="selectedContacts.length != 0">)</span>
            </label>
            <input type="hidden" formControlName="Contacts" />
            <app-contact-input
              [style.height.px]="messageEditorHeight < 70 ? 40 : (messageEditorHeight - 44 + 17)"
              [startValues]="selectedContacts"
              [contactList]="contactList"
              (contactChange)="onContactChange($event)"
            ></app-contact-input>
          </div>
          <div class="tab tags" *ngIf="rightTabView === 'tags'">
            <label>
              <span
                i18n="tag label input indicator|The label above the tag input list selector at the delivery form modal@@tagInputLabelDeliveryModal"
              >Tags</span>
              <span></span>
              <span *ngIf="selectedTags.length != 0"> (</span>
              <span
                *ngIf="selectedTags.length == 1"
                i18n="one tag selected sufix|The sufix at the right of the tag label that lets the user know there is a single tag selected@@tagLabelSufixSingleDeliveryModal"
              >1 tag selected</span>
              <span *ngIf="selectedTags.length > 1">
                <span>{{ selectedTags.length }}</span>
                <span style="margin-left: 4px;" i18n="plural tag count sufix|The qualifier sufix at the right of the number of tags currently selected for a delivery@@tagLabelSufixPluralDeliveryModal">tags selected</span>
              </span>
              <span *ngIf="selectedTags.length != 0">)</span>
            </label>
            <input type="hidden" formControlName="Tags" />
            <app-tag-list-input
              [style.height.px]="messageEditorHeight < 70 ? 40 : (messageEditorHeight - 44 + 17)"
              [startValues]="selectedTags"
              [availableTags]="availableTags"
              (tagChange)="onTagChange($event)"
            ></app-tag-list-input>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="form-error-area" *ngIf="forceFormShowError && (deliveryForm.invalid || isEmptyDestination())">
    <ul class="alert alert-danger">
      <li
        *ngIf="isEmptyDestination()"
        i18n="@@emptyDestinationDeliveryForm"
      >No contacts or tags have been selected. Please include someone to be the recipient of the message.</li>
      <li
        *ngIf="Contacts.invalid"
        i18n="contacts input is invalid|Error message indicating that the Contacts input value is empty or invalid@@contactsErrorMessage"
      >At least a single contact is required</li>
      <li
        *ngIf="Subject.invalid"
        i18n="subject input is invalid|Error message indicating that the Subject input value is empty or invalid@@subjectErrorMessage"
      >The subject field is required</li>
      <li
        *ngIf="Message.invalid"
        i18n="message input is invalid|Error message indicating that the Message input value is empty or invalid@@messageErrorMessage"
      >The message field is required</li>
      <li
        *ngIf="!Contacts.invalid && !Subject.invalid && !Message.invalid && !isEmptyDestination()"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</li>
    </ul>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="onCancelClick()">
    <span i18n="cancel changes delivery action|The label of the button used to close the delivery form, cancelling changes if they were made, at the delivery form modal@@cancelChangesDeliveryAction">Close</span>
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmitClick()">
    <span *ngIf="isNew" i18n="create delivery final main action|The label of the button used to finish the creation of a delivery at the delivery form modal@@newDeliveryFinalActionLabel">Create</span>
    <span *ngIf="!isNew" i18n="update delivery final main action|The label of the button used to finish the edition of a previously created delivery at the delivery form modal@@updateDeliveryFinalActionLabel">Save</span>
  </button>
</div>

<app-pbi-report-view
  [openModal]="eventOpenmodal.asObservable()"
  [updateFilter]="eventUpdateFilter.asObservable()"
  [workspaceId]="workspaceId"
  [reportId]="reportId"
  [showFooter]="true"
  [showFilter]="true"
  [showPages]="true"
  (filters)="onSubmitFilter($event)"
></app-pbi-report-view>
